import { render, staticRenderFns } from "./home-tienda.vue?vue&type=template&id=4612975e&scoped=true&"
import script from "./home-tienda.vue?vue&type=script&lang=js&"
export * from "./home-tienda.vue?vue&type=script&lang=js&"
import style0 from "./home-tienda.vue?vue&type=style&index=0&id=4612975e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4612975e",
  null
  
)

export default component.exports